// Product-specific journey URLs for the header "Get Started" CTA.
// Keep in sync with the finance options in components/Common/CallToAction.
export const JOURNEY_URLS = {
  vehicle: 'https://dash.driva.com.au/welcome',
  personal: 'https://dash.driva.com.au/pl/loan',
  novated: 'https://www.driva.com.au/novated-lease-calculator/',
};

// Path fragments that map a page to a non-vehicle journey. Everything else
// (car / asset finance, calculators, generic pages) uses the vehicle journey.
const NOVATED_PATHS = ['novated'];
const PERSONAL_PATHS = ['personal-loan', 'debt-consolidation', 'holiday-loan', 'renovation-loan'];

// Resolve the CTA destination for a given page.
// Priority: explicit Prismic navLink URL, then the product inferred from the
// page path, then the vehicle journey as the default.
export const resolveJourneyUrl = ({ navLinkUrl, pathname }) => {
  if (navLinkUrl) return navLinkUrl;

  const path = (pathname || '').toLowerCase();

  // Blog articles keep the default CTA unless a Prismic link is set, so a topic
  // mention doesn't hijack the button.
  if (path.includes('/blog/')) return JOURNEY_URLS.vehicle;

  if (NOVATED_PATHS.some((fragment) => path.includes(fragment))) return JOURNEY_URLS.novated;
  if (PERSONAL_PATHS.some((fragment) => path.includes(fragment))) return JOURNEY_URLS.personal;

  return JOURNEY_URLS.vehicle;
};
